// Module
var code = `<span class="tft-label {{tftLabelCtrl.labelClass}}" data-test-id="{{tftLabelCtrl.testId}}" ng-if="tftLabelCtrl.valueKey"> {{tftLabelCtrl.valueKey | translate }} </span> `;
// Exports
export default code;